import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';

@Injectable({ providedIn: 'root' })
export class CompanyProductBillingAccessGuard implements CanActivate {
  private readonly permissions = inject(PermissionsService);

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    if (this.permissions.isDepartment('direction') || this.permissions.isDepartment('rrhh')) {
      return true;
    }

    const company_product_id = this.resolveCompanyProductId(route);
    if (company_product_id === null) {
      return false;
    }

    return this.permissions.isAccountManagerInCompanyProduct(company_product_id);
  }

  private resolveCompanyProductId(route: ActivatedRouteSnapshot): string | null {
    let current_route: ActivatedRouteSnapshot | null = route;

    while (current_route !== null) {
      const company_product_id = current_route.paramMap.get('id') ?? current_route.paramMap.get('company_product_id');
      if (company_product_id !== null) {
        return company_product_id;
      }

      current_route = current_route.parent;
    }

    const query_company_product_id = route.queryParamMap.get('company_product_id');
    return query_company_product_id;
  }
}
